export const DefaultPermissions = [
    {
        id: 'VIEW',
        value: 'Can view',
        subtitle: 'View & download files',
        isSelectable: true,
    },
    {
        id: 'CONTRIBUTE',
        value: 'Can upload',
        subtitle: 'Add files ,view & download',
        isSelectable: true,
    },
    {
        id: 'MANAGE',
        value: 'Can manage',
        subtitle: 'Create and manage folders, content& permissions',
        isSelectable: true,
    },
    {
        divider: true,
    },
    {
        value: 'Remove',
        id: 'NONE',
        subtitle: '',
        isSelectable: true,
    },
];
export var ResponseStatus;
(function (ResponseStatus) {
    ResponseStatus[ResponseStatus["Success"] = 0] = "Success";
    ResponseStatus[ResponseStatus["Failed"] = 1] = "Failed";
})(ResponseStatus || (ResponseStatus = {}));
export var CloseReason;
(function (CloseReason) {
    CloseReason[CloseReason["Cancel"] = 0] = "Cancel";
    CloseReason[CloseReason["SaveSucceed"] = 1] = "SaveSucceed";
})(CloseReason || (CloseReason = {}));
export var Loading;
(function (Loading) {
    Loading[Loading["InProgress"] = 0] = "InProgress";
    Loading[Loading["Success"] = 1] = "Success";
    Loading[Loading["Error"] = 2] = "Error";
})(Loading || (Loading = {}));
export var Direction;
(function (Direction) {
    Direction["LTR"] = "ltr";
    Direction["RTL"] = "rtl";
})(Direction || (Direction = {}));
export var Theme;
(function (Theme) {
    Theme["DASHBOARD"] = "dashboard";
    Theme["SITE"] = " site";
})(Theme || (Theme = {}));
//# sourceMappingURL=EntityAdvancedPermissionsTypes.js.map